import { render, staticRenderFns } from "./real-time-alarm-dialog.vue?vue&type=template&id=81da2204&scoped=true"
import script from "./real-time-alarm-dialog.vue?vue&type=script&lang=js"
export * from "./real-time-alarm-dialog.vue?vue&type=script&lang=js"
import style0 from "./real-time-alarm-dialog.vue?vue&type=style&index=0&id=81da2204&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81da2204",
  null
  
)

export default component.exports